import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';
import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 

const styles = StyleSheet.create({
       

          
    
          to: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'left',
          },


          indent: {
            marginBottom: 5, 
            textAlign: 'justify',
            marginLeft: 10,
          },
          signature: {
            textAlign: 'right',     // to align text to the right
            marginTop: 30,          // optional: add some space on top
          },
          
        });


        
const PensionForm7 = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>Form 7</Text>
                <Text style={[style.subtitle, style.ArialItalic]}>[See Rule 123 (1)]</Text>
                <Text style={[style.subtitle, {fontSize: 10}]}>
                  Form of letter to the Audit Officer forwarding the pension of a Government Servant
                </Text>

                <View style={style.solidLine} />

                <View style={styles.to}>
                  <Text>To,</Text>
                  <Text>The Joint Director of Education</Text>
                  <Text>Higher Education</Text>
                  <Text>{result.region} Region, {result.city}.</Text>
                </View>

     
               
                <AutoText style={[style.paragraph, { marginTop: 10 }, { marginBottom: 10 }]}>

                Subject: Pension papers of {result?.employeeName}, {result.designation}, {result.institutionName} for authorization of pension.
                </AutoText>

                <Text >Respected Sir,</Text>
              <View style={{marginLeft:10}}>
                <AutoText style={style.paragraph}>1. I am directed to forward herewith the pension papers of {result?.employeeName} for further necessary action.</AutoText>


                <View style={{ flexDirection: 'row', marginBottom: 8 }}>
                <Text style={style.paragraph}>2.</Text>
                <View style={{ marginLeft: 5, flex: 1 }}>
                    <Text >The details of Government dues which will remain outstanding on the date of the retirement of the Government servant and which need to be recovered out of the amount of Death-cum-Retirement Gratuity are indicated below:</Text>
                </View>
                </View>

                <View style={styles.indent}>
  {[
    "a) Balance of the house building or conveyance advance and festival advance:",
    "b) Over Payment of pay and allowances including leave salary:",
    "c) Income Tax deductible at source under the Income Tax Act, 1961 (43 of 1961):",
    "d) Arrears of licence fee for occupation of Government accommodation:",
    "e) Licence fee for retention of Government accommodation beyond the date of retirement:",
    "f) Other assessed dues and their nature:",
    "g) Amount of gratuity to be withheld for adjustment of unassessed dues if any:"
  ].map((label, index) => (
    <View key={index} style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
      <Text style={{ flex: 1}}>{label}</Text>
      <Text style={[style.ArialBold, , {marginRight:60} ]}>NIL</Text>
    </View>
  ))}


  <Text style={{ marginTop: 10, marginRight: 65, textAlign: 'right' }}>
    TOTAL Rs. 00
  </Text>
</View>

                <View style={{ flexDirection: 'row', marginBottom: 8 }}>
                <Text style={style.paragraph}>3.</Text>
                <View style={{ marginLeft: 5, flex: 1 }}>
                    <AutoText >a) No departmental enquiry is either pending or proposed to be held against {result?.employeeName}</AutoText>
                    <AutoText >b) Departmental enquiry is pending / or proposed to be held against {result?.employeeName} and a provisional pension amounting to Rs. ..NIL.. per month with effect from .. NIL.. to .. NIL.. has been sanctioned.</AutoText>
                </View>
                </View>


                <Text style={style.paragraph}>4.   Your attention is invited to the list of enclosures which is forwarded herewith.</Text>

                <View style={{ flexDirection: 'row', marginBottom: 8 }}>
                <Text style={style.paragraph}>5.</Text>
                <View style={{ marginLeft: 5, flex: 1 }}>
                    <Text> The receipt of this letter may be acknowledged and this Department/ Office informed that necessary instructions for the disbursement of pension have been issued to concerned Treasury Office.</Text>
                </View>
                </View>


                
                <View style={{ flexDirection: 'row', marginBottom: 8 }}>
                <Text style={style.paragraph}>6.</Text>
                <View style={{ marginLeft: 5, flex: 1 }}>
                    <Text> The death-cum-retirement gratuity will be drawn and disbursed by this department/ Office on receipt of
                            authority from you. The outstanding Government dues as mentioned in para 2 above will be recovered out of
                            the death-cum-retirement gratuity before making payment.</Text>
                </View>
                </View>


                <Text style={[style.signature, style.ArialItalic]}>Yours faithfully, </Text>
                <Text style={[style.signature, style.ArialItalic, {marginTop: 40}]}>Head of Office </Text>
              </View>
              </View>

);

export default PensionForm7;